import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(67, 89, 112, 0.87);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20;
`;

export const ModalContainer = styled.div`
    position: relative;
    background: white;
    border-radius: 10px;
    padding: 24px;
    width: 70%;
    height: 50%;
    min-height: 450px;
    min-width: 900px;
    max-width: 1400px;
    box-shadow: 0 4px 38px rgba(64, 89, 111, 0.51);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Title = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #40596f;
`;

export const RemoveAll = styled.span`
    font-size: 14px;
    color: #40596f;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
        color: #00a5ac;
    }
`;

export const HorizontalLine = styled.hr`
    border: 1px solid #40596f59;
    margin: 8px 0;
`;

export const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 64px;
    padding: 24px 0;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 12px;
    .checkbox-label {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #40596f;
        cursor: pointer;
        &:hover {
            color: #00a5ac;
        }
    }
    &.search-options {
        input {
            border: 1px solid #40596f;
            border-radius: 4px;
        }
    }

    &.search-options:hover {
        opacity: 0.8;
    }
    .checkbox-input {
        svg {
            color: #40596f;
            stroke: white;
        }
    }
    .checkbox-input-checked {
        svg {
            color: #00a5ac;
            stroke: white;
            &:hover {
                color: #00a5ac;
            }
        }
    }
    .select {
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid #40596f;
        font-size: 14px;
        color: #40596f;
        background-color: white;
        cursor: pointer;
        &:hover {
            opacity: 0.8;
        }
    }
`;

export const SectionTitle = styled.h4`
    font-size: 16px;
    font-weight: 600;
    color: #40596f;
    margin: 0;
`;

export const Footer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    bottom: 24px;
    right: 24px;
    gap: 12px;
`;
